import { createAction, props } from '@ngrx/store';
import {
  LocationHistory,
  LocationHistoryStats,
  LocationSearchPayload,
} from '../../services/location-history.service';

export const loadLocationHistory = createAction(
  '[LocationHistory] Load LocationHistory',
  props<{ payload: LocationSearchPayload }>(),
);

export const loadLocationHistorySuccess = createAction(
  '[LocationHistory] Load LocationHistory Success',
  props<{ locationHistoryList: LocationHistory[] }>(),
);

export const loadLocationHistoryFailure = createAction(
  '[LocationHistory] Load LocationHistory Failure',
  props<{ error: any }>(),
);

export const loadLocationHistoryStats = createAction(
  '[LocationHistory] Load location history stats',
  props<{ payload: LocationSearchPayload }>(),
);

export const getCurrentVehicleHistory = createAction(
  '[LocationHistory] Get current vehicle history',
  props<{ payload: LocationSearchPayload }>(),
);
export const getCurrentVehicleHistorySuccess = createAction(
  '[LocationHistory] Get current vehicle history Success',
  props<{ payload: LocationHistory[] }>(),
);

export const loadLocationHistoryStatsSuccess = createAction(
  '[LocationHistory] Load location history stats Success',
  props<{ payload: LocationHistoryStats[] }>(),
);
